import React, { useState, useRef, useCallback } from "react";
import { Bell } from "lucide-react";
import useNotificationStore from "../../store/useNotificationStore";
import NotificationDrawer from "./NotificationDrawer";
import AnchoredPanel from "../shared/AnchoredPanel";
import { useTheme } from "../../context/ThemeProvider";

const NotificationBell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const { theme } = useTheme();

  const unreadCount = useNotificationStore(
    (state) => state.notifications.filter((n) => !n.read).length
  );

  const handleToggle = () => setIsOpen((prev) => !prev);
  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <button
        ref={triggerRef}
        onClick={handleToggle}
        title="Notifications"
        className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
          isOpen
            ? "bg-fill-gray-200 dark:bg-fill-canvas-hover"
            : "hover:bg-fill-gray-200 dark:hover:bg-fill-canvas-hover"
        }`}
      >
        <div className="relative">
          <Bell
            size={18}
            className={theme === "dark" ? "text-ink-white" : "text-ink-control-border"}
          />
          {unreadCount > 0 && (
            <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-[16px] flex items-center justify-center rounded-full bg-fill-primary text-ink-on-primary text-[10px] font-semibold leading-none px-[3px]">
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </div>
      </button>

      <AnchoredPanel
        anchorRef={triggerRef}
        isOpen={isOpen}
        onClose={handleClose}
        width={360}
        align="right"
      >
        <NotificationDrawer onClose={handleClose} />
      </AnchoredPanel>
    </>
  );
};

export default NotificationBell;
